
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export interface UserStats {
  reviewCount: number;
  totalPoints: number;
  memberDays: number;
  isLoading: boolean;
}

export const useUserStats = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState<UserStats>({
    reviewCount: 0,
    totalPoints: 0,
    memberDays: 0,
    isLoading: true
  });

  useEffect(() => {
    const fetchUserStats = async () => {
      if (!user) {
        setStats(prev => ({ ...prev, isLoading: false }));
        return;
      }

      try {
        // 獲取用戶資料和積分
        const { data: profile } = await supabase
          .from('profiles')
          .select('points, created_at')
          .eq('id', user.id)
          .single();

        // 獲取評論數量
        const { count: reviewCount } = await supabase
          .from('reviews')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id);

        // 計算會員天數
        const memberDays = profile?.created_at 
          ? Math.floor((Date.now() - new Date(profile.created_at).getTime()) / (1000 * 60 * 60 * 24))
          : 0;

        setStats({
          reviewCount: reviewCount || 0,
          totalPoints: profile?.points || 0,
          memberDays,
          isLoading: false
        });
      } catch (error) {
        console.error('Error fetching user stats:', error);
        setStats(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchUserStats();
  }, [user]);

  return stats;
};
